export default __webpack_public_path__ + "static/media/schemat5.9f908a35.png";